export default __webpack_public_path__ + "static/blob10-f6ae973242fbb657497320be9e7f5195.svg";